import api from "../utils/api";

function getUserMail() {
  const user = localStorage.getItem("adm_panel_user");
  if (!user) return null;

  try {
    return JSON.parse(user).email;
  } catch {
    return null;
  }
}

/* =========================
   GET NOTIFICATIONS
========================= */

export async function fetchNotifications() {
  try {
    const res = await api.get("/notifications", {
      headers: {
        "X-User-Mail": getUserMail(),
      },
    });

    return res.data;
  } catch (err) {
    throw new Error("Failed to fetch notifications");
  }
}

/* =========================
   GET UNREAD COUNT
========================= */

export async function fetchUnreadCount() {
  try {
    const res = await api.get("/notifications/unread-count", {
      headers: {
        "X-User-Mail": getUserMail(),
      },
    });

    return res.data;
  } catch (err) {
    throw new Error("Failed to fetch unread count");
  }
}

/* =========================
   MARK AS READ
========================= */

export async function markNotificationRead(notificationId) {
  try {
    const res = await api.post(
      "/notifications/read",
      { notificationId },
      {
        headers: {
          "X-User-Mail": getUserMail(),
        },
      }
    );

    return res.data;
  } catch (err) {
    throw new Error("Failed to mark notification as read");
  }
}

/* =========================
   DELETE
========================= */

export async function deleteNotification(notificationId) {
  try {
    const res = await api.post(
      "/notifications/delete",
      { notificationId },
      {
        headers: {
          "X-User-Mail": getUserMail(),
        },
      }
    );

    return res.data;
  } catch (err) {
    throw new Error("Failed to delete notification");
  }
}